import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { size } from '../../utils/common'

const useStyles = theme => ({
    footer: {
        padding: '0.5rem',
        textAlign: 'center'
    }
})

const StyledDiv = styled.div`
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 9;
    @media (max-width: ${size.tabletL}) {
        display: none;
    }
`

class FooterPage extends Component {
    render() {
        const { classes } = this.props
        const { model_name, theme_color, theme_font_color, footer_text_html, show_like_the_website_form } = this.props.auth.appSettings
        const likeTheWebsite = show_like_the_website_form ?
            <>&nbsp;|&nbsp;<Link to='/like-the-website' style={{ color: theme_font_color }}>Like the website? Contact me</Link></>
            : null
        return (
            <div style={{ paddingBottom: '90px' }}>
                <StyledDiv className={classes.footer} style={{ backgroundColor: theme_color, color: theme_font_color, wordBreak: 'break-word' }}>
                    <div className='mb-1'>
                        <Link to='/terms-of-service' style={{ color: theme_font_color, fontSize: '14px' }}>Terms of Service</Link>&nbsp;|&nbsp;
                        <Link to='/privacy-policy' style={{ color: theme_font_color, fontSize: '14px' }}>Privacy Policy</Link>&nbsp;|&nbsp;
                        <Link to='/dmca' style={{ color: theme_font_color, fontSize: '14px' }}>DMCA</Link>&nbsp;|&nbsp;
                        <Link to='/2257' style={{ color: theme_font_color, fontSize: '14px' }}>2257</Link>&nbsp;|&nbsp;
                        <Link to='/content-removal' style={{ color: theme_font_color, fontSize: '14px' }}>Content Removal</Link>&nbsp;|&nbsp;
                        <Link to='/faq' style={{ color: theme_font_color, fontSize: '14px' }}>FAQ</Link>&nbsp;|&nbsp;
                        <Link to='/contact-us' style={{ color: theme_font_color, fontSize: '14px' }}>Contact/Support</Link>
                        {likeTheWebsite}
                    </div>
                    {footer_text_html === '' ?
                        <>&copy; Copyright @{new Date().getFullYear()} {model_name} Find more models at <a target='_blank' href='https://fanfavour.com' rel='noopener noreferrer' style={{ color: theme_font_color }}>fanfavour</a></>
                        :
                        <>&copy; Copyright @{new Date().getFullYear()} <span dangerouslySetInnerHTML={{ __html: footer_text_html }} style={{ color: theme_font_color }}></span></>
                    }
                </StyledDiv>
            </div>
        )
    }
}

FooterPage.propTypes = {
    auth: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth
})

export default connect(
    mapStateToProps
)(withStyles(useStyles)(FooterPage))
